<template>
  <div v-show="isCardActiveLocal">
    <div class="w-full" v-show="!isCategoryListHidden">      
      <vs-table stripe ref="categoriesTable" class="vs-con-loading__container" single @selected="handleSelectedCategory" pagination max-items="10" search :data="categories"> <!-- v-scroll-to="'#categoryInfoCard'" -->
        <div v-if="!isCourseReadOnly" slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <!-- ADD NEW -->
          <div ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewCategory">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">{{ $siteTypeId() == 1 ? 'Add New Module' : 'Add New Category' }}</span>
          </div>
        </div>
        <template slot="thead">
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="modifiedOn">Modified On</vs-th>
          <vs-th sort-key="modifiedBy">Modified By</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="categorie" :key="indextr" v-for="(categorie, indextr) in data" >

            <vs-td :data="data[indextr].name">
              {{ categorie.name }}
            </vs-td>

            <vs-td :data="data[indextr].modifiedOn">
              {{ categorie.modifiedOn ? categorie.modifiedOn.replace("T", " ").split('.')[0] : "" }}
            </vs-td>

            <vs-td :data="data[indextr].modifiedBy">
              {{ categorie.modifiedBy }}
            </vs-td>

            <vs-td>
              <div class="flex" v-if="categoryLoaded">
                <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="right" :disabled="!data[indextr].number"  icon="icon-arrow-up" @click="moveIndexUp(data[indextr].id)"></vs-button>
                <vs-button color="dark" size="small" type="line" icon-pack="feather" line-origin="left" :disabled="data[indextr].number == categories[categories.length - 1].number"   icon="icon-arrow-down" @click="moveIndexDown(data[indextr].id)"></vs-button>
              </div>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div>
      <vx-card id="categoryInfoCard" ref="categoryInfo" :title="$siteTypeId() == 1 ? 'Module Info' : 'Category Info'" v-show="!isInfoHidden">
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Name</label>
            <vs-input autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required'" name="Name" v-model="formData.name" />
            <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
          </div>
        </div>

        <vs-divider></vs-divider>
        
        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button color="success" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="saveEditCategory" ref="saveEditButton">Save</vs-button>
            <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" v-show="formData.id" @click="deleteCategory" ref="deleteButton">Delete</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="cancelAdd">Cancel</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      loadingColor: "#fff",
      selected: [],
      isInfoHidden: true,
      isCategoryListHidden: false,
      categories: [{
        number:0
      }],
      categoryLoaded : false,
      formData: {
        id: 0,
        courseId: 0,
        name: "",
      },
      mode: "",
      changeIndex:false,
    };
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
    sourceCourseId: {
      type: Number,
      required: false
    },
    isCourseReadOnly: {
      type: Boolean,
      required: false
    },
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeCard");
          this.initValues();
        }
      }
    }
  },
  watch: {
    isCardActive: function(val) {
      if(val){
        var self = this;
        self.loadCategoryData();
        self.formData.courseId = self.sourceCourseId;
      }
    }
  },
  methods: {
    initValues() {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.courseId = this.sourceCourseId;
      this.mode = "";
      this.errors.clear();
      this.changeIndex = false;
    },
    cancelAdd() {
      this.initValues();
      this.isInfoHidden = true;
      this.isCategoryListHidden = false;
    },
    addNewCategory() {
      this.initValues();
      this.isCategoryListHidden = true;
      this.isInfoHidden = false;
      this.mode = "Add Category";
    },
    saveData() {
      this.loadCategoryData();
      this.$vs.loading.close(this.$refs.saveEditButton.$el);
    },
    loadCategoryData() {
      const self = this;
      self.showLoadingOnElement("categoriesTable", 1, "corners");

      var onSuccess = function(response) {
        self.categories = response.data;
        self.categoryLoaded = true;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.categoriesTable.$el);
      };

      self.$ajaxGet(self, "ModuleCategory/ListModuleCategories/" + self.sourceCourseId, onSuccess, onFinally);
    },
    handleSelectedCategory(category) {
      if(this.changeIndex){
        return
      }
      if(!this.isCourseReadOnly) {
        this.mode = "Edit Category";
        this.formData.id = category.id;
        this.formData.name = category.name;
        this.isCategoryListHidden = true;
        this.isInfoHidden = false;
      }
    },
    saveEditCategory() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnElement("saveEditButton", 0.45, "material");

          var onSuccess = response => {
            self.saveData();
            self.isInfoHidden = true;
            self.isCategoryListHidden = false;
            self.$vs.notify({
              title: "Information",
              color: "success",
              text: `${self.$siteTypeId() == 1 ? 'Module' : 'Category'} Saved`,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function() {
            self.$vs.loading.close(self.$refs.saveEditButton.$el);
          };

          self.$ajaxPost(self, "ModuleCategory/AddEditModuleCategory", self.formData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    deleteCategory() {
      var self = this;
      self.showLoadingOnElement("deleteButton", 0.45, "material");

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.isCategoryListHidden = false;
        self.isInfoHidden = true;
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: `${self.$siteTypeId() == 1 ? 'Module' : 'Category'} Deleted`,
          text: "Category Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };

      self.$ajaxDelete(self, "ModuleCategory/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    moveIndexUp(moduleId){
      var self = this;
      self.changeIndex = true;
      self.showLoadingOnElement("categoriesTable",1,"corners");

      var index = self.categories.findIndex(x=>x.id == moduleId); 
      var swapModuleId = self.categories[index - 1].id;
      var onSuccess = response =>{
        self.loadCategoryData();
      }
    
      var onFinally = response =>{
        if(self.$refs.categoriesTable){
          self.$vs.loading.close(self.$refs.categoriesTable.$el);
        }
         self.$vs.notify({
          title:'Information',
          color: "success",
          text: `Order changed`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info'
        });
        self.changeIndex = false;
      }
    
      self.$ajaxGet(self, `ModuleCategory/ChangeIndex?originalId=${moduleId}&swapCategory=${swapModuleId}` , onSuccess, onFinally);
    },
    moveIndexDown(moduleId){
      var self = this;
      self.changeIndex = true;
      self.showLoadingOnElement("categoriesTable",1,"corners");

      var index = self.categories.findIndex(x=>x.id == moduleId); 
      var swapModuleId = self.categories[index + 1].id;
      var onSuccess = response =>{
        self.loadCategoryData();
      }
    
      var onFinally = response =>{
        if(self.$refs.categoriesTable){
          self.$vs.loading.close(self.$refs.categoriesTable.$el);
        }
         self.$vs.notify({
          title:'Information',
          color: "success",
          text: `Order changed`,
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-info'
        });
        self.changeIndex = false;
      }
    
      self.$ajaxGet(self, `ModuleCategory/ChangeIndex?originalId=${swapModuleId}&swapCategory=${moduleId}` , onSuccess, onFinally);
    },
  }
};
</script>
